<template>
  <div class="s-strip s-leasing-car">
    <div class="page-container">
      <div class="row gx-5">
        <div class="col-xl-6">
          <div class="s-leasing-car__header mb-20">
            <h1 class="h1 extrabold mb-5">{{ make }} {{ model }}</h1>
            <h2 class="h4">{{ modelDescription }}</h2>
          </div>

          <div class="s-leasing-car__gallery mb-32">
            <div v-if="highlightText" class="s-leasing-car__tagged">
              <span>{{ highlightText }}</span>
            </div>
            <VehicleGallerySlick
              v-if="recordsGallery.length"
              :records="recordsGallery" />
            <div
              v-if="recordsGallery.length"
              class="d-flex justify-content-end">
              <small>
                <i>{{ dictionary.galleryDisclaimer }}</i>
              </small>
            </div>
          </div>

          <section
            v-if="dictionary.limitedDisclaimer"
            class="s-contact-note mb-20">
            <div class="s-contact-note__body">
              <div class="s-contact-note__details">
                <div class="s-contact-note__picture">
                  <IdeaLottie width="20"></IdeaLottie>
                </div>

                <div>
                  <div
                    class="s-contact-note__description"
                    v-html="dictionary.limitedDisclaimer"></div>
                </div>
              </div>
            </div>
          </section>

          <VehicleTechs v-if="hasSpecs" :item="carSpecs" />

          <LeasingCarSaverAside
            v-if="yearsOption"
            :key="key"
            class="d-block d-xl-none"
            id-prefix="year-devices"
            :years-option="yearsOption"
            :with-prepayment="withPrepayment"
            @update-years-option="changeYearsOption"
            @update-with-prepayment="changeWithPrepayment" />

          <VehicleBenefits
            v-if="characteristics?.length"
            :records="characteristics"
            :columns="2"
            class="mb-20" />
        </div>
        <div class="col-xl-6">
          <LeasingCarSaverAside
            v-if="yearsOption"
            :key="key"
            class="d-none d-xl-block"
            id-prefix="year-desktop"
            :years-option="yearsOption"
            :with-prepayment="withPrepayment"
            @update-years-option="changeYearsOption"
            @update-with-prepayment="changeWithPrepayment" />

          <section v-if="leasingTerms" class="s-contact-note mb-80">
            <div class="s-contact-note__body">
              <div class="s-contact-note__details">
                <div class="s-contact-note__picture">
                  <IdeaLottie width="20"></IdeaLottie>
                </div>

                <div>
                  <div
                    class="s-contact-note__description"
                    v-html="leasingTerms"></div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from './../../lib/lib'
import VehicleGallerySlick from './../components/leaseitnow/VehicleGallerySlick.vue'
import IdeaLottie from './../components/lotties/Idea.vue'
/* eslint-disable no-unused-vars */
import { difference, last, remove, sum, uniqBy } from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import VehicleTechs from './../components/leasingOffers/VehicleTechs.vue'
import VehicleBenefits from './../components/VehicleBenefits.vue'
import LeasingCarSaverAside from '../components/LeasingCarSaverAside.vue'

export default {
  components: {
    VehicleGallerySlick,
    VehicleTechs,
    IdeaLottie,
    VehicleBenefits,
    LeasingCarSaverAside,
  },
  data() {
    return {
      key: uuidv4(),
      isLoading: false,
      errorMsgs: [],
      // data sources
      make: '',
      model: '',
      modelDescription: '',
      highlightBgColor: '',
      highlightText: '',

      carSpecs: {
        transmissionType: '',
        fuel: '',
        consumption: '',
        energyConsumption: '',
        autonomy: '',
        emissions: '',
      },

      leaseSaverCharacteristics: [],
      leaseFlexCharacteristics: [],
      galleryImages: [],
      characteristics: [],

      leasingTerms: '',
      withPrepayment: true,

      programms: [],
      yearsOption: 0,
    }
  },
  computed: {
    hasSpecs() {
      return Object.entries(this.carSpecs).find((x) => x[1] !== '')
    },

    recordsGallery() {
      if (!this.galleryImages) {
        return []
      }
      return this.galleryImages.map((x) => ({
        id: uuidv4(),
        thumbnail: { url: x.url, alt: '' },
        image: { url: x.url, alt: '' },
      }))
    },
  },
  mounted() {
    const {
      make,
      model,
      modelDescription,
      highlightBgColor,
      highlightText,
      galleryImages,
      transmission,
      fuel,
      consumption,
      energyConsumption,
      autonomy,
      emissions,
      retailPriceBeforeTaxes,

      characteristics,

      leaseSaverCharacteristics,

      leaseFlexCharacteristics,

      programms,
      leasingTerms,
    } = lib.getData('leasingCarSaverData')
    this.make = make
    this.model = model
    this.modelDescription = modelDescription
    this.highlightBgColor = highlightBgColor
    this.highlightText = highlightText
    this.galleryImages = galleryImages

    this.carSpecs.transmissionType = transmission
    this.carSpecs.fuel = fuel
    this.carSpecs.consumption = consumption
    this.carSpecs.energyConsumption = energyConsumption
    this.carSpecs.autonomy = autonomy
    this.carSpecs.emissions = emissions
    this.carSpecs.retailPriceBeforeTaxes = retailPriceBeforeTaxes

    if (characteristics) {
      this.characteristics = characteristics.map((x) => {
        return { summary: x }
      })
    }

    this.leaseSaverCharacteristics = leaseSaverCharacteristics

    this.leaseFlexCharacteristics = leaseFlexCharacteristics

    this.leasingTerms = leasingTerms

    const firstOption = this.getFirstOption(programms)
    this.yearsOption = firstOption ? firstOption.years : 1
  },
  methods: {
    getFirstOption(programms) {
      const { saver, flex } = programms
      const optionsMerged = [...saver, ...flex]
      optionsMerged.sort((a, b) => a.years - b.years)

      return optionsMerged[0]
    },
    changeYearsOption(value) {
      this.yearsOption = value
      this.key = uuidv4()
    },
    changeWithPrepayment(value) {
      this.withPrepayment = value
    },
  },
}
</script>
<style lang="scss" scoped>
.s-leasing-car__tagged {
  background-color: v-bind(highlightBgColor);
  color: white;
}
.s-contact-note__body {
  width: 100%;
}
</style>
